module.exports = __webpack_public_path__ + "img/CREDIT_CARD.3978b4f1.svg";